import { TourContext, TourContextType } from "@/contexts/TourContext";
import { useContext } from "react";

export const useTour = (): TourContextType => {
  const context = useContext(TourContext);
  if (context === undefined) {
    throw new Error("useTour must be used within a TourProvider");
  }
  return context;
};
